module.exports = __webpack_public_path__ + "3527bb54410b0852238c29b1cff230a5.svg";